
import axios from "axios";

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    
    const token = sessionStorage.getItem("token");
    console.log("admin token")

    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: response interceptor for expired token
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
       if (error?.message === "Token Invalid/Expired") {
          console.warn("Unauthorized or token expired");
          alert("Session expired. Redirecting to login...");
          sessionStorage.removeItem("token");
          window.location.href = "/Login";
    }
    
  }
  return Promise.reject(error);
}
);
